<div #container *ngIf="pointsAccounts.length > 0">
  <div class="multi-card-selector-container flex w-full">
    <div
      class="anz-card-select-container mr-4 flex flex-col"
      *ngFor="let pointsAccount of pointsAccounts; let i = index">
      <p class="default-card m-0 mb-4 h-4">
        <ng-container *ngIf="defaultPointsAccountId === pointsAccount.id">
          {{ 'wl.anz.card_select.default_card' | translate }}
        </ng-container>
      </p>
      <anz-card-select
        [loyaltyCurrency]="loyaltyCurrency"
        [pointsAccount]="pointsAccount"
        [id]="i">
      </anz-card-select>
    </div>
  </div>
</div>
<div
  class="indicator-group my-0 mx-auto flex w-full"
  *ngIf="pointsAccounts.length > 0">
  <div
    class="indicator"
    *ngFor="let pointsAccount of pointsAccounts; let i = index"
    [id]="i"
    [class.active]="i === cardInFocus"></div>
</div>
